import { render } from "./float-btn.vue?vue&type=template&id=7e2bc466&scoped=true"
import script from "./float-btn.vue?vue&type=script&lang=js"
export * from "./float-btn.vue?vue&type=script&lang=js"

import "./float-btn.vue?vue&type=style&index=0&id=7e2bc466&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2bc466"]])

export default __exports__